<script lang="ts">
  import { useLocation } from 'svelte-navigator';
  // @ts-ignore
  import cashbackBanner from '../assets/20260730_Abbildung Antragsseite CB Raeder & Reifen.png';

  const location = useLocation();

  $: isStep1 =
    $location.pathname === '/step/1' ||
    $location.pathname === '/' ||
    $location.pathname === '';
</script>

{#if isStep1}
  <div class="mx-auto w-full max-w-7xl px-4 pt-4 sm:px-8 sm:pt-6">
    <div class="py-2 sm:py-4">
      <img
        class="mx-auto w-full object-contain"
        src={cashbackBanner}
        alt="Mercedes-Benz Winterkomplettrad Cashback-Aktion 2026"
      />
    </div>
  </div>
{/if}
